<!--
 * @Description: 省份模板管理-弹框
 * @Author: 
 * @Date: 2022-12-28 11:41:16
 * @LastEditTime: 2024-03-12 18:22:25
 * @LastEditors: Jky200guo guohongyuan@jiankeyan.com
 * @Usage: 
-->

<template>
  <el-dialog
    title="新增"
    :visible.sync="addDialogVisible"
    width="30%"
    center
    :close-on-click-modal="false"
    :before-close="close"
  >
        <div
    id="nav-bar"
  >
    <div class="nav">
      <span
        v-for="item in list"
        :key="item.id"
        :class="{'active' :item.actived === 1}"
        @click="itemClick(item)"
      >
        {{ item.name }}
      </span>
    </div>
  </div>

      <div class="box">
        <el-form
          ref="ruleForm"
          :model="form"
          label-width="140px"
          :rules="rules"
        >
          <el-row>
            <el-col v-if="currentTab===1">
              <el-col >
              <el-form-item
                label="公司:"
                prop="authorityCompanyIds"
              >
              <el-select
                  filterable 
                  v-model="form.authorityCompanyIds"
                  placeholder="请选择"
                  multiple
                  
                >
                  <el-option
                    v-for="pro in  options"
                    :key="pro.id"
                    :label="pro.companyName"
                    :value="pro.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col >
              <el-form-item
                label="定制化地址:"
                prop="actionUrl"
              >
                <el-input maxlength="40" v-model="form.actionUrl"></el-input>
              </el-form-item>
            </el-col>
            </el-col>
            <el-col v-if="currentTab===2">
            <el-col>
              <el-form-item
                label="公司:"
                prop="authorityCompanyIds"
              >
              <el-select
              filterable 
                  v-model="form.authorityCompanyIds"
                  placeholder="请选择"
                  @change="handleChange"
                 
                >
                  <el-option
                    v-for="pro in  options"
                    :key="pro.id"
                    :label="pro.companyName"
                    :value="pro.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="项目:"
                prop="authorityProjectIds"
              >
              <el-select
              filterable 
                  v-model="form.authorityProjectIds"
                  placeholder="请选择"
                  @change="handleChange2"
                  multiple
                  
                >
                  <el-option
                  v-for="pro in  options2"
                    :key="pro.id"
                    :label="pro.projectName"
                    :value="pro.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col >
              <el-form-item
                label="定制化地址:"
                prop="actionUrl"
              >
                <el-input maxlength="40" v-model="form.actionUrl"></el-input>
              </el-form-item>
            </el-col>
            </el-col>
            <el-col         
      class="dialog-footer"
      style="text-align: center;"
    >
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        @click="submit('ruleForm'); "
      >确 定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </el-dialog>
</template>

<script>
import { BASE_URL } from '@/util/constant'
import { Api_SuperAdmin } from "@/api/api";
export default {
  mixins: [],
  data() {
    return {
      options: [],
      addDialogVisible: false,
      form: {
        "id": 0,
        "authorityCompanyIds": [],
        "authorityProjectIds": [],
        "specificType": 1,
        "actionUrl": "",
        "isEnable": true
      },
      rules: {
        authorityCompanyIds: [{
          required: true,
          message: "请选择公司",
          trigger: "blur",
        }],
        authorityProjectIds: [{
          required: true,
          message: "请选择项目",
          trigger: "blur",
        }],
        actionUrl: [{
          required: true,
          message: "请输入定制化地址",
          trigger: "blur",
        }],
      },
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      baseUrl: BASE_URL,
      currentTab: 1,
      options2:[],
      list:[{id:1,name:'公司定制化',actived:1 },{id:2,name:'项目定制化',actived:0,isClick: false,}]
      // isIndeterminate: true
    };
  },
  components: {
  },
  created() {
    this.getList()
  },
  methods: {
    close() {
      this.clear()
            this.addDialogVisible = false
        },
        submit(formName) {
          this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.currentTab==2){
              let arr =[]
              arr.push(this.form.authorityCompanyIds)
              this.form.authorityCompanyIds=arr
            }
            Api_SuperAdmin.addCustomized(this.form).then((res) => {
            const { data } = res
          if (data.statusCode === 200) {
            this.$message({
              type: "success",
              message: "保存成功!",
            });
            this.$emit('updateList')
            this.close()
          } else {
            this.$showMessage("失败", data.errors);
            if(this.currentTab==2){
              this.form.authorityCompanyIds=this.form.authorityCompanyIds[0]
            }
          }
      });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
 
           
        },
    getList() {
      Api_SuperAdmin.list({
        pageSize: 9999,
        pageIndex: 1,
        companyName: "",
        status: 0,
      }).then((res) => {
        this.options = res.data.data.tList;
      });
      
    },
    handleChange(val){
      this.form.authorityProjectIds=[]
      Api_SuperAdmin.projectList({
        pageSize: 9999,
        pageIndex: 1,
        authorityCompanyId: val,
        projectType: -1,
        projectNam: "",
        status: -1,
      }).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.options2 = result.data.tList;
        }
      })
    },
    handleChange2(val){
      this.form.authorityProjectIds=val
     
    },
    itemClick(val) {
      this.form = {
        "id": 0,
        "authorityCompanyIds": [],
        "authorityProjectIds": [],
        "specificType": val.id,
        "actionUrl": "",
        "isEnable": true
      }
      this.options2=[]
      this.list.forEach((ele) => {
        if (ele.id === val.id) {
          ele.actived = 1;
          ele.isClick = true;
        } else {
          ele.actived = 0;
          ele.isClick = false;
        }
      });
      setTimeout(()=>{
       this.currentTab=val.id
      },200)      
    },
    open() {
      this.addDialogVisible = true
      this.clear()
      this.list.forEach((ele) => {
        if (ele.id === 1) {
          ele.actived = 1;
          ele.isClick = true;
        }else{
          ele.actived = 0;
          ele.isClick = false;
        }
      });
      
    },
    clear() {
      this.form = {
        "id": 0,
        "authorityCompanyIds": [],
        "authorityProjectIds": [],
        "specificType": 1,
        "actionUrl": "",
        "isEnable": true
      }
      setTimeout(()=>{
       this.currentTab=1
      },200)    
    },
  },
};
</script>
<style lang="scss" scoped>
.home-img {
  height: 55px;
}
.container {
  margin-top: 20px;
  .box {
    padding: 20px;
    border: 1px solid #365f7d;
    margin: 10px 0 20px;
  }

  .inner-box {
    border: 1px solid #365f7d;
    padding: 10px;
  }

  .check-all {
    display: flex;
    align-items: flex-start;
  }
}
#nav-bar {
  width: 100%;
  text-align: center;
  .nav {
    padding: 20px 0;
    padding-left: 10px;
    box-sizing: border-box;
    overflow-x: auto;
    white-space: nowrap;
    span {
      // width: 140px;
      // height: 40px;
      padding: 10px 10px;
      line-height: 40px;
      text-align: center;
      margin-right: 20px;
      background: #22386d;
      color: #61d2f7;
      font-size: 14px;
      font-weight: bold;
      word-break: keep-all;
      cursor: pointer;
    }
    .en {
      padding: 10px 2px;
      margin-right: 4px;
    }
    .active {
      background: #2f65ec !important;
    }
  }
}
</style>